import axios from "axios";
import i18n from "./i18n";

let toastFn = null;
let logoutFn = null;

/**
 * Call once from a React component that has access to useToast().
 * Registers a global axios response interceptor that shows error toasts.
 */
export const setupAxiosInterceptor = (toastError, logout) => {
  if (toastFn) return; // already registered
  toastFn = toastError;
  logoutFn = logout;

  // Send cookies (auth_token) with every request — cookie-based auth
  axios.defaults.withCredentials = true;

  axios.interceptors.response.use(
    (response) => response,
    (error) => {
      if (axios.isCancel(error)) return Promise.reject(error);

      const status = error.response?.status;
      const message = error.response?.data?.message;

      if (status === 401) {
        // Token expired or invalid — auto-logout
        if (logoutFn) logoutFn();
        return Promise.reject(error);
      }

      if (status === 403) return Promise.reject(error);

      if (!error.response) {
        // Network error
        toastFn("Network error — please check your connection.");
      } else if (status >= 500) {
        toastFn(message || i18n.t("common.server_error", { defaultValue: "Something went wrong on our end. Please try again." }));
      } else if (status === 404) {
        // Silently skip 404s — they're often expected
      } else if (status === 400 || status === 422) {
        // Validation errors — let the calling code handle these
      } else {
        toastFn(message || `Request failed (${status}).`);
      }

      return Promise.reject(error);
    }
  );
};
